"use client";

import styles from "./LoginPageHeader.module.scss";

import { WEBSITE_URL } from "@/constants";
import { buildSignUpHrefWithNext } from "@/helpers";
import { useTranslations, useLocale } from "@/i18n";
import { useSearchParams } from "react-router-dom";
import { Flex } from "@vetty/ui";

/**
 * LoginPageHeader Component
 *
 * Navigation header for login page with logo and menu links.
 * Preserves safe `next` when linking to sign-up (authorize continuation).
 */
export const LoginPageHeader = () => {
  const t = useTranslations("login.header");
  const locale = useLocale();
  const [searchParams] = useSearchParams();
  const nextParam = searchParams.get("next");

  return (
    <Flex align={"center"} justify={"space-between"} className={styles["comp"]}>
      <a href={`${WEBSITE_URL}/${locale}`} className={styles["comp__logo-link"]}>
        <img
          className={styles["comp__logo"]}
          src="/assets/logo-dark.svg"
          alt="Vetty"
        />
      </a>

      <Flex align={"center"} gap={36} className={styles["comp__menu"]}>
        <a
          href={`${WEBSITE_URL}/${locale}/university#contact-sales`}
          className={styles["comp__menu__item"]}
        >
          {t("contactSales")}
        </a>

        <a
          href={buildSignUpHrefWithNext(locale, nextParam)}
          className={styles["comp__menu__item"]}
        >
          {t("signUp")}
        </a>
      </Flex>
    </Flex>
  );
};
